import React from 'react'
import PropTypes from 'prop-types'
import { Text, Margin } from 'shared/components'
import { MobileFilters } from '../mobileFilters'

import * as styles from './styles'

const MobileHeaderComponent = ({
	title = 'Tournaments',
	selectedSportType,
	onSportTypeChange,
}) => {
	return (
		<div css={styles.header}>
			<div css={styles.headerContent}>
				<Margin bottom={3}>
					<div css={styles.titleContainer}>
						<img
							src="./img/inwin-tiny-white-logo.png"
							alt="InWin Logo"
							css={styles.logo}
						/>
						<Text size={20} bold white css={styles.title}>
							{title}
						</Text>
					</div>
				</Margin>

				<MobileFilters
					selectedSportType={selectedSportType}
					onSportTypeChange={onSportTypeChange}
				/>
			</div>
		</div>
	)
}

MobileHeaderComponent.propTypes = {
	title: PropTypes.string,
	selectedSportType: PropTypes.string,
	onSportTypeChange: PropTypes.func.isRequired,
}

export default MobileHeaderComponent 